import React from "react";
import { Droppable } from "react-beautiful-dnd";
import {
    Box,
    Paper,
    Typography,
    IconButton,
    Badge,
    makeStyles
} from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import OpportunityCard from "../OpportunityCard";

const useStyles = makeStyles((theme) => ({
    column: {
        minWidth: 250,
        maxWidth: 250,
        marginRight: theme.spacing(1.5),
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 250px)"
    },
    header: {
        padding: theme.spacing(1),
        borderRadius: "8px 8px 0 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        color: "#fff",
        fontWeight: 600
    },
    headerTitle: {
        fontSize: "0.85rem",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.75)
    },
    content: {
        flex: 1,
        overflowY: "auto",
        padding: theme.spacing(0.75),
        backgroundColor: "#f5f5f5",
        borderRadius: "0 0 8px 8px",
        ...theme.scrollbarStyles
    },
    contentDraggingOver: {
        backgroundColor: "#e3f2fd"
    },
    emptyState: {
        textAlign: "center",
        padding: theme.spacing(3),
        color: theme.palette.text.secondary,
        fontSize: "0.85rem"
    },
    addButton: {
        color: "#fff",
        padding: 4
    },
    badge: {
        "& .MuiBadge-badge": {
            backgroundColor: "#fff",
            color: "#333",
            fontWeight: 600
        }
    }
}));

const KanbanColumn = ({ card, opportunities, onAddOpportunity, onUpdate }) => {
    const classes = useStyles();

    const getHeaderColor = (color) => {
        return color || "#3498db";
    };

    const getCardIcon = (type) => {
        switch (type) {
            case "conversao":
                return "✅";
            case "perda":
                return "❌";
            default:
                return "📋";
        }
    };

    return (
        <Box className={classes.column}>
            <Box
                className={classes.header}
                style={{ backgroundColor: getHeaderColor(card.color) }}
            >
                <Typography className={classes.headerTitle}>
                    <span>{getCardIcon(card.type)}</span>
                    <span>{card.name}</span>
                    <Badge
                        badgeContent={opportunities.length}
                        className={classes.badge}
                        max={99}
                    />
                </Typography>
                <IconButton
                    size="small"
                    className={classes.addButton}
                    onClick={() => onAddOpportunity && onAddOpportunity(card.id)}
                >
                    <AddIcon fontSize="small" />
                </IconButton>
            </Box>

            <Droppable droppableId={String(card.id)}>
                {(provided, snapshot) => (
                    <Box
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className={`${classes.content} ${snapshot.isDraggingOver ? classes.contentDraggingOver : ""
                            }`}
                    >
                        {opportunities.length === 0 ? (
                            <Typography className={classes.emptyState}>
                                Nenhuma oportunidade
                            </Typography>
                        ) : (
                            opportunities.map((opportunity, index) => (
                                <OpportunityCard
                                    key={opportunity.id}
                                    opportunity={opportunity}
                                    index={index}
                                    onUpdate={onUpdate}
                                />
                            ))
                        )}
                        {provided.placeholder}
                    </Box>
                )}
            </Droppable>
        </Box>
    );
};

export default KanbanColumn;
